import { Clock, AlertTriangle } from 'lucide-react';
import { cn } from '../../lib/utils';

const EXPIRY_DAYS = 7;

export default function ExpiryBadge({ createdAt }) {
  if (!createdAt) return null;

  const createdDate = createdAt.toDate ? createdAt.toDate() : new Date(createdAt);
  const expiryDate = new Date(createdDate.getTime() + EXPIRY_DAYS * 24 * 60 * 60 * 1000);
  const now = new Date();
  const msLeft = expiryDate - now;
  const daysLeft = Math.ceil(msLeft / (24 * 60 * 60 * 1000));

  if (daysLeft <= 0) {
    return (
      <span className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full border',
        'bg-red-100 text-red-700 border-red-200',
        'dark:bg-red-900/30 dark:text-red-400 dark:border-red-700'
      )}>
        <AlertTriangle className="w-3 h-3" />
        Expires today
      </span>
    );
  }

  const Icon = daysLeft <= 1 ? AlertTriangle : Clock;

  const colorClasses = daysLeft <= 1
    ? 'bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-700'
    : daysLeft <= 3
      ? 'bg-yellow-100 text-yellow-700 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-400 dark:border-yellow-700'
      : 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-700';

  return (
    <span className={cn(
      'inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full border',
      colorClasses
    )}>
      <Icon className="w-3 h-3" />
      {daysLeft} {daysLeft === 1 ? 'day' : 'days'} left
    </span>
  );
}
